import apiUrl from "../util/apiURL";

const Version = "2016-03-04";
const Service = "vpc";

export default {
    //绑定专线 VPN
    BatchAssociateNat: {
        url: apiUrl({
            Action: "BatchAssociateNat",
            Service: "vpc",
            Version
        }),
        method: "post"
    },
    //解绑专线 VPN
    BatchDisassociateNatPost: {
        url: apiUrl({
            Action: "BatchDisassociateNat",
            Service: "vpc",
            Version
        }),
        method: "post"
    },
    //VPN通道列表
    DescribeVpnTunnelsAll: apiUrl({
        Action: "DescribeVpnTunnels",
        Service,
        Version
    }),
    //专线网关
    getSubnetDcList: apiUrl({
        Action: "DescribeDirectConnectGateways",
        Service,
        Version
    }),
    DescribeDirectConnectGateways: apiUrl({
        Action: "DescribeDirectConnectGateways",
        Service,
        Version
    }),
    //VPN网关列表
    DescribeVpnGateways: apiUrl({
        Action: "DescribeVpnGateways",
        Service,
        Version
    }),
    //获取项目制
    getAllotDataNew: apiUrl({
        Action: "GetAccountAllProjectList",
        Service: "iam",
        Version: "2015-11-01"
    }),
    //子网 acl别的调这个获取VPC的接口
    DescribeVpcInfos: apiUrl({
        Service: "vpc",
        Action: "DescribeVpcInfos",
        Version
    }),
    //更换网络IP 子网禁用IP信息
    DescribeSubnetAllocatedIpAddresses: apiUrl({
        Service: "vpc",
        Action: "DescribeSubnetAllocatedIpAddresses",
        Version
    }),
    // 查询子网内网IP信息
    DescribePrivateIpAddressAttributes: {
        url: apiUrl({
            Action: "DescribePrivateIpAddressAttributes",
            Service: "vpc",
            Version
        }),
        method: "post"
    },
    // 子网修改内网IP属性
    BatchModifyPrivateIpAddressAttribute: {
        url: apiUrl({
            Action: "BatchModifyPrivateIpAddressAttribute",
            Service: "vpc",
            Version
        }),
        method: "post"
    },
    //判断是否接入试用转正
    GetFreeTrialWallet: apiUrl({
        Service: "network",
        Action: "GetFreeTrialWallet",
        Version
    }),
    // //专线网关
    // getSubnetDcList:apiUrl('/api',{
    //     Action: 'DescribeDirectConnectGateways',
    //     Service,
    //     Version
    // }),
    //可用区
    DescribeAvailabilityZones: apiUrl({
        Action: "DescribeAvailabilityZones",
        Service: "vpc",
        Version
    }),
    //修改VPC名称
    ModifyVpc: apiUrl({
        Action: "ModifyVpc",
        Service,
        Version
    }),
    //编辑ACL规则
    BatchEditNetworkAclEntry: {
        url: apiUrl({
            Action: "BatchEditNetworkAclEntry",
            Service: "vpc",
            Version
        }),
        method: "post"
    },
    //批量新建ACL规则
    BatchCopyNetworkAclEntry: {
        url: apiUrl({
            Action: "BatchCopyNetworkAclEntry",
            Service: "vpc",
            Version
        }),
        method: "post"
    },
    //批量修改一个安全组的安全组规则
    BatchEditSecurityGroupEntry: {
        url: apiUrl({
            Action: "BatchEditSecurityGroupEntry",
            Service: "vpc",
            Version
        }),
        method: "post"
    },
    //批量替换安全组规则接口
    BatchReplaceSecurityGroupEntry: {
        url: apiUrl({
            Action: "BatchReplaceSecurityGroupEntry",
            Service: "vpc",
            Version
        }),
        method: "post"
    },
    //批量新增安全组规则接口
    BatchAuthorizeSecurityGroupEntry: {
        url: apiUrl({
            Action: "BatchAuthorizeSecurityGroupEntry",
            Service: "vpc",
            Version
        }),
        method: "post"
    },
    //批量删除安全组规则接口
    BatchRevokeSecurityGroupEntry: {
        url: apiUrl({
            Action: "BatchRevokeSecurityGroupEntry",
            Service: "vpc",
            Version
        }),
        method: "post"
    },
    //复制安全组
    BatchCopySecurityGroupEntry: {
        url: apiUrl({
            Action: "BatchCopySecurityGroupEntry",
            Service: "vpc",
            Version
        }),
        method: "post"
    },
    // 更换网络
    ModifyNetworkInterfaceAttributes: {
        url: apiUrl({
            Action: "BatchModifyNetworkInterfaceAttribute",
            Service: "kec",
            Version
        }),
        method: "post"
    },
    //云物理主机
    ModifyNetworkInterfaceAttributesEpc: {
        url: apiUrl({
            Action: "BatchModifyNetworkInterfaceAttribute",
            Service: "epc",
            Version: "2015-11-01"
        }),
        method: "post"
    },
    DescribeVpcs: apiUrl({
        Action: "DescribeVpcs",
        Service,
        Version
    }),
    //获取NAT的列表
    DescribeNats: apiUrl({
        Action: "DescribeNats",
        Service,
        Version
    }),
    // 点击支付 跳转到订单页
    CreateProduct: {
        url: apiUrl({
            Action: "CreateProductOfNat",
            Service,
            Version
        }),
        method: "post"
    },
    // 点击立即创建 新建NAT
    CreateNatPrivate: apiUrl({
        Action: "CreateNat",
        Service,
        Version
    }),
    //获取续费的价格
    BatchCalculateProduct: apiUrl({
        Action: "CalculateProduct",
        Service,
        Version
    }),
    //获取物理机列表
    DescribePhysicsOfIgw: apiUrl({
        Action: "ListEpcsInInternetGateway",
        Service,
        Version
    }),
    // //物理机--未绑定的弹性IP
    // DescribePysicDisAssociate:apiUrl('/api', {
    //     Action: 'DescribeAddressesDisAssociate',
    //     Service: 'eip',
    //     Version
    // }),
    //物理机--未绑定的云服务
    VmListPysic: apiUrl({
        Action: "ListUnboundEpcsInInternetGateway",
        Service,
        Version
    }),
    // //创建物理机 点击确定
    // AssociatePysic:apiUrl('/api', {
    //     Action: 'AssociateAddress',
    //     Service:'eip',
    //     Version
    // }),

    //=VPC  NAT计费//
    //获取未绑定子网的列表
    DescribeSubnetsDisassociateNat: apiUrl({
        Action: "DescribeSubnetsDisassociateNat",
        Service,
        Version
    }),
    //获取IP地址数量的最大值
    getIpAmount: apiUrl({
        Action: "DescribeQuotaSystemOfNat",
        Service,
        Version
    }),
    //获取计费方式 和 带宽最大和最小值
    getCharType: apiUrl({
        Action: "DescribePriceSystemOfNAT",
        Service: "price",
        Version
    }),
    getNatChargeType: apiUrl({
        Action: "DescribePriceSystemOfNAT",
        Service: "price",
        Version
    }),
    //计算价格  新建NAT价格 续费价格 调整带宽价格
    CalculateProductAll: {
        url: apiUrl({
            Action: "CalculateProductOfNat",
            Service,
            Version
        }),
        method: "post"
    },
    ModifyNat: apiUrl({
        Action: "ModifyNat",
        Service,
        Version
    }),
    BatchDeleteNat: apiUrl({
        Action: "BatchDeleteNat",
        Service,
        Version
    }),
    AssociateNat: apiUrl({
        Action: "AssociateNat",
        Service,
        Version
    }),
    BatchDisassociateNat: apiUrl({
        Action: "BatchDisassociateNat",
        Service,
        Version
    }),
    // 获取安全组数据
    DescribeSecurityGroups: apiUrl({
        Action: "DescribeSecurityGroups",
        Service,
        Version
    }),
    DescribeInstances: apiUrl({
        Action: "DescribeInstances",
        Service,
        Version
    }),
    DescribeNetworkInterfaces: apiUrl({
        Action: "DescribeNetworkInterfaces",
        Service,
        Version
    }),
    ModifySecurityGroup: apiUrl({
        Action: "ModifySecurityGroup",
        Service,
        Version
    }),
    CreateSecurityGroup: apiUrl({
        Action: "CreateSecurityGroup",
        Service,
        Version
    }),
    DeleteSecurityGroups: apiUrl({
        Action: "DeleteSecurityGroups",
        Service,
        Version
    }),
    AuthorizeSecurityGroupEntry: apiUrl({
        Action: "AuthorizeSecurityGroupEntry",
        Service,
        Version
    }),
    DeleteSecurityGroupEntrys: {
        url: apiUrl({
            Action: "DeleteSecurityGroupEntrys",
            Service,
            Version
        }),
        method: "post"
    },
    ModifyNetworkInterfaceAttribute: apiUrl({
        Action: "ModifyNetworkInterfaceAttribute",
        Service: "kec",
        Version
    }),
    ModifySecurityGroupEntry: {
        url: apiUrl({
            Action: "ModifySecurityGroupEntry",
            Service,
            Version
        }),
        method: "post"
    },
    // acl
    DescribeNetworkAcls: apiUrl({
        Action: "DescribeNetworkAcls",
        Service,
        Version
    }),
    ModifyNetworkAcl: apiUrl({
        Action: "ModifyNetworkAcl",
        Service,
        Version
    }),
    CreateNetworkAcl: apiUrl({
        Action: "CreateNetworkAcl",
        Service,
        Version
    }),
    DeleteNetworkAcls: apiUrl({
        Action: "DeleteNetworkAcls",
        Service,
        Version
    }),
    DescribeSubnets: apiUrl({
        Action: "DescribeSubnets",
        Service,
        Version
    }),
    CreateNetworkAclEntry: apiUrl({
        Action: "CreateNetworkAclEntry",
        Service,
        Version
    }),
    DeleteNetworkAclEntrys: apiUrl({
        Action: "DeleteNetworkAclEntrys",
        Service,
        Version
    }),
    ListUnBoundSubnetsInAcl: apiUrl({
        Action: "ListUnBoundSubnetsInAcl",
        Service,
        Version
    }),
    AssociateNetworkAcl: apiUrl({
        Action: "AssociateNetworkAcl",
        Service,
        Version
    }),
    DisassociateNetworkAcls: apiUrl({
        Action: "DisassociateNetworkAcls",
        Service,
        Version
    }),
    ModifyNetworkAclEntry: apiUrl({
        Action: "ModifyNetworkAclEntry",
        Service,
        Version
    }),
    QueryRoutesCount: apiUrl({
        Action: "QueryRoutesCount",
        Service,
        Version
    }),
    DescribeRoutes: apiUrl({
        Action: "DescribeRoutes",
        Service,
        Version
    }),
    DescribeTunnels: apiUrl({
        Action: "DescribeTunnels",
        Service,
        Version
    }),
    CreateRoute: apiUrl({
        Action: "CreateRoute",
        Service,
        Version
    }),
    DeleteRoutes: apiUrl({
        Action: "DeleteRoutes",
        Service,
        Version
    }),
    DescribeVpcPeeringConnections: apiUrl({
        Action: "DescribeVpcPeeringConnections",
        Service,
        Version
    }),
    //对等连接 价格体系获取计费方式和带宽
    DescribePriceSystemOfPeering: apiUrl({
        Action: "DescribePriceSystemOfPeering",
        Service: "price",
        Version
    }),
    //对等连接 计算价格
    CalculateProductOfPeering: {
        url: apiUrl({
            Action: "CalculateProductOfPeering",
            Service: "vpc",
            Version
        }),
        method: "post"
    },
    //走订单创建对等连接
    CreateProductOfPeering: {
        url: apiUrl({
            Action: "CreateProductOfPeering",
            Service: "vpc",
            Version
        }),
        method: "post"
    },
    ListUnBoundVpcsInPeering: apiUrl({
        Action: "ListUnBoundVpcsInPeering",
        Service,
        Version
    }),
    CreateVpcPeeringConnection: apiUrl({
        Action: "CreateVpcPeeringConnection",
        Service,
        Version
    }),
    DeleteVpcPeeringConnections: apiUrl({
        Action: "DeleteVpcPeeringConnection",
        Service,
        Version
    }),
    DeleteVpcPeeringConnection: apiUrl({
        Action: "DeleteVpcPeeringConnection",
        Service,
        Version
    }),
    AcceptVpcPeeringConnection: apiUrl({
        Action: "AcceptVpcPeeringConnection",
        Service,
        Version
    }),
    RejectVpcPeeringConnection: apiUrl({
        Action: "RejectVpcPeeringConnection",
        Service,
        Version
    }),
    QueryVPC: apiUrl({
        Action: "QueryVPC",
        Service,
        Version
    }),
    CreateDefaultVPC: apiUrl({
        Action: "CreateDefaultVPC",
        Service,
        Version
    }),
    DeleteVpcs: apiUrl({
        Action: "DeleteVpcs",
        Service,
        Version
    }),
    CreateVpc: apiUrl({
        Action: "CreateVpc",
        Service,
        Version
    }),
    CreateSubnet: apiUrl({
        Action: "CreateSubnet",
        Service,
        Version
    }),
    CreateNat: apiUrl({
        Action: "CreateNat",
        Service,
        Version
    }),
    ModifySubnetPeer: apiUrl({
        Action: "ModifyVpcPeeringConnection",
        Service,
        Version
    }),
    ModifySubnet: apiUrl({
        Action: "ModifySubnet",
        Service,
        Version
    }),
    QuerySubnet: apiUrl({
        Action: "QuerySubnet",
        Service,
        Version
    }),
    ListEpcs: apiUrl({
        Action: "ListEpcs",
        Service,
        Version
    }),
    DeleteSubnets: apiUrl({
        Action: "DeleteSubnets",
        Service,
        Version
    }),
    DescribeSubnetAvailableAddresses: apiUrl({
        Action: "DescribeSubnetAvailableAddresses",
        Service,
        Version
    }),
    SwitchSubnets: apiUrl({
        Action: "SwitchSubnets",
        Service,
        Version
    }),
    GetNatMinitorDate: apiUrl({
        Action: "GetNatMinitorDate",
        Service: "nat",
        Version
    }),
    DescribeInternetGateways: apiUrl({
        Action: "DescribeInternetGateways",
        Service,
        Version
    }),
    ModifyTunnel: apiUrl({
        Action: "ModifyTunnel",
        Service,
        Version
    }),
    AssociateRemoteCidr: apiUrl({
        Action: "AssociateRemoteCidr",
        Service,
        Version
    }),
    DisassociateRemoteCidr: apiUrl({
        Action: "DisassociateRemoteCidr",
        Service,
        Version
    }),
    BatchDisassociateRemoteCidr: apiUrl({
        Action: "BatchDisassociateRemoteCidr",
        Service,
        Version
    }),
    ListUnBoundSubnetsIntunnels: apiUrl({
        Action: "ListUnBoundSubnetsIntunnels",
        Service,
        Version
    }),
    AssociateSubnet: apiUrl({
        Action: "AssociateSubnet",
        Service,
        Version
    }),
    DisassociateSubnet: apiUrl({
        Action: "DisassociateSubnet",
        Service,
        Version
    }),
    //获取续费价格 peer
    BatchCalculateProductPeer: {
        url: apiUrl({
            Action: "BatchCalculateProduct",
            Service,
            Version
        }),
        method: "post"
    },
    //续费 peer queding
    BatchCreateProduct: {
        url: apiUrl({
            Action: "BatchCreateProduct",
            Service,
            Version
        }),
        method: "post"
    },
    //VPN通道列表
    DescribeVpnTunnels: apiUrl({
        Action: "DescribeVpnTunnelsByVpcId",
        Service,
        Version
    }),
    AssociateVpcCidrBlock: apiUrl({
        Action: "AssociateVpcCidrBlock",
        Service: "vpc",
        Version: "2016-03-04"
    }),
    //查看用户有没有云智联权限
    GetCenUserPermission: apiUrl({
        Action: "GetCenUserPermission",
        Service: "cen",
        Version: "2016-03-04"
    }),

    //查询云企业网授权信息
    DescribeCenGrants: apiUrl({
        Action: "DescribeCenGrants",
        Service: "cen",
        Version: "2016-03-04"
    }),
    //创建云企业网授权信息
    CreatCenGrant: apiUrl({
        Action: "CreatCenGrant",
        Service: "cen",
        Version: "2016-03-04"
    }),
    //删除云企业网授权信息
    DeleteCenGrant: apiUrl({
        Action: "DeleteCenGrant",
        Service: "cen",
        Version: "2016-03-04"
    }),
    //获取cen区域信息
    DescribeRegionGroups: apiUrl({
        Action: "DescribeRegionGroups",
        Service: "cen",
        Version: "2016-03-04"
    }),
    //查询云企业网带宽包
    DescribeCenBandWidthPackages: {
        url: apiUrl({
            Action: "DescribeCenBandWidthPackages",
            Service: "cen",
            Version
        }),
        method: "post"
    },
    ModifyCenRegionBandwidth: apiUrl({
        Action: "ModifyCenRegionBandwidth",
        Service: "cen",
        Version: "2016-03-04"
    }),
    DeleteCenRegionBandwidth: apiUrl({
        Action: "DeleteCenRegionBandwidth",
        Service: "cen",
        Version: "2016-03-04"
    }),
    //绑定云企业网带宽包
    AttachCenBandWidthPackage: apiUrl({
        Action: "AttachCenBandWidthPackage",
        Service: "cen",
        Version: "2016-03-04"
    }),
    //解绑云企业网带宽包
    DetachCenBandWidthPackage: apiUrl({
        Action: "DetachCenBandWidthPackage",
        Service: "cen",
        Version: "2016-03-04"
    }),
    //Cen价格体系
    DescribePriceSystemOfCen: apiUrl({
        Action: "DescribePriceSystemOfCen",
        Service: "price",
        Version: "2016-03-04"
    }),
    BatchCalculateProductOfCen: {
        url: apiUrl({
            Action: "BatchCalculateProductOfCen",
            Service: "cen",
            Version
        }),
        method: "post"
    },
    //新建云企业网带宽包
    BatchCreateProductOfCen: {
        url: apiUrl({
            Action: "BatchCreateProductOfCen",
            Service: "cen",
            Version
        }),
        method: "post"
    },
    // 新建云智联
    CreateCic: apiUrl({
        Action: "CreateCen",
        Service: "cen",
        Version: "2016-03-04"
    }),
    DescribeCics: apiUrl({
        Action: "DescribeCens",
        Service: "cen",
        Version: "2016-03-04"
    }),
    ModifyCic: apiUrl({
        Action: "ModifyCen",
        Service: "cen",
        Version: "2016-03-04"
    }),
    BatchDeleteCens: {
        url: apiUrl({
            Action: "BatchDeleteCens",
            Service: "cen",
            Version
        }),
        method: "post"
    },
    DescribeCenRoutes: {
        url: apiUrl({
            Action: "DescribeCenRoutes",
            Service: "cen",
            Version
        }),
        method: "post"
    },
    DescribeCenInstances: {
        url: apiUrl({
            Action: "DescribeCenInstances",
            Service: "cen",
            Version
        }),
        method: "post"
    },
    DescribeCenRegions: apiUrl({
        Action: "DescribeCenRegions",
        Service: "cen",
        Version: "2016-03-04"
    }),
    DescribeCanBindCicVpcs: apiUrl({
        Action: "DescribeCanBindCenVpcs",
        Service: "vpc",
        Version: "2016-03-04"
    }),
    DescribeCicBindCicDcGateway: apiUrl({
        Action: "DescribeCenBindCenDcGateway",
        Service: "vpc",
        Version: "2016-03-04"
    }),
    AttachCenInstance: apiUrl({
        Action: "AttachCenInstance",
        Service: "cen",
        Version: "2016-03-04"
    }),
    BatchDetachCenInstances: {
        url: apiUrl({
            Action: "BatchDetachCenInstances",
            Service: "cen",
            Version
        }),
        method: "post"
    },
    DescribeCenRegionBandwidths: apiUrl({
        Action: "DescribeCenRegionBandwidths",
        Service: "cen",
        Version: "2016-03-04"
    }),
    CreateCenRegionBandwidth: apiUrl({
        Action: "CreateCenRegionBandwidth",
        Service: "cen",
        Version: "2016-03-04"
    }),
    ModifyCicInterRegionBandwidth: apiUrl({
        Action: "ModifyCicInterRegionBandwidth",
        Service: "vpc",
        Version: "2016-03-04"
    }),
    DeleteCicInterRegionBandwidth: apiUrl({
        Action: "DeleteCicInterRegionBandwidth",
        Service: "vpc",
        Version: "2016-03-04"
    }),
    GetRouteTableUserPermission: apiUrl({
        Action: "GetRouteTableUserPermission",
        Service: "vpc",
        Version: "2016-03-04"
    }),

    CreateNetworkInterface: apiUrl({
        Action: "CreateNetworkInterface",
        Service,
        Version
    }),

    DeleteNetworkInterface: apiUrl({
        Action: "DeleteNetworkInterface",
        Service,
        Version
    }),

    queryKecListNotInVnet: apiUrl({
        Action: "queryKecListNotInVnet",
        Service: "kec",
        Version
    }),

    QueryKecListByAzCode: apiUrl({
        Action: "QueryKecListByAzCode",
        Service: "kec",
        Version
    }),

    AttachNetworkInterface: apiUrl({
        Action: "AttachNetworkInterface",
        Service: "kec",
        Version
    }),

    DetachNetworkInterface: apiUrl({
        Action: "DetachNetworkInterface",
        Service: "kec",
        Version
    }),

    CheckIPv6Quota: apiUrl({
        Action: "CheckIPv6Quota",
        Service: "vpc",
        Version: "2016-03-04"
    }),

    AllocateSubnetIpv6CidrBlock: apiUrl({
        Action: "AllocateSubnetIpv6CidrBlock",
        Service: "vpc",
        Version: "2016-03-04"
    }),
    DescribeWebRouteTables: {
        url: apiUrl({
            Action: "DescribeWebRouteTables",
            Service,
            Version
        }),
        method: "post"
    },
    DescribeInstancesByVpc: apiUrl({
        Action: "DescribeInstancesByVpc",
        Service,
        Version
    }),
    BatchPublishRouteToCic: {
        url: apiUrl({
            Action: "BatchPublishRouteToCic",
            Service,
            Version
        }),
        method: "post"
    },
    BatchCancelRouteToCic: {
        url: apiUrl({
            Action: "BatchCancelRouteToCic",
            Service,
            Version
        }),
        method: "post"
    },
    DescribeNatRateLimits: apiUrl({
        Action: "DescribeNatRateLimits",
        Service,
        Version
    }),
    QueryNatRateLimitCount: apiUrl({
        Action: "QueryNatRateLimitCount",
        Service,
        Version
    }),
    CreateNatRateLimit: apiUrl({
        Action: "CreateNatRateLimit",
        Service,
        Version
    }),
    ModifyNatRateLimit: apiUrl({
        Action: "ModifyNatRateLimit",
        Service,
        Version
    }),
    DeleteNatRateLimit: apiUrl({
        Action: "DeleteNatRateLimit",
        Service,
        Version
    }),
    ModifyNetworkInterface: {
        url: apiUrl({
            Action: "ModifyNetworkInterface",
            Service,
            Version
        }),
        method: "post"
    },
    QueryRouteTablesCount: apiUrl({
        Action: "QueryRouteTablesCount",
        Service: "vpc",
        Version: "2016-03-04"
    }),
    BatchDeleteRouteTables: {
        url: apiUrl({
            Action: "BatchDeleteRouteTables",
            Service,
            Version
        }),
        method: "post"
    },
    CreateDnat: {
        url: apiUrl({
            Action: "CreateDnat",
            Service,
            Version
        }),
        method: "post"
    },
    DescribeRouteTableRoutes: apiUrl({
        Action: "DescribeRouteTableRoutes",
        Service,
        Version
    }),
    CreateRouteTableRoute: apiUrl({
        Action: "CreateRouteTableRoute",
        Service: "vpc",
        Version: "2016-03-04"
    }),
    CreateRouteTable: apiUrl({
        Action: "CreateRouteTable",
        Service: "vpc",
        Version: "2016-03-04"
    }),
    BatchDeleteRouteTableRoutes: {
        url: apiUrl({
            Action: "BatchDeleteRouteTableRoutes",
            Service,
            Version
        }),
        method: "post"
    },
    DeleteDnat: {
        url: apiUrl({
            Action: "DeleteDnats",
            Service,
            Version
        }),
        method: "post"
    },
    BatchDisassociateRouteTables: {
        url: apiUrl({
            Action: "BatchDisassociateRouteTables",
            Service,
            Version
        }),
        method: "post"
    },
    ModifyDnat: {
        url: apiUrl({
            Action: "ModifyDnat",
            Service,
            Version
        }),
        method: "post"
    },
    AssociateInstance: {
        url: apiUrl({
            Action: "BatchAssociateInstance",
            Service,
            Version
        }),
        method: "post"
    },
    DisassociateInstance: {
        url: apiUrl({
            Action: "BatchDisassociateInstance",
            Service,
            Version
        }),
        method: "post"
    },
    AssociateRouteTable: apiUrl({
        Action: "AssociateRouteTable",
        Service: "vpc",
        Version: "2016-03-04"
    }),
    DescribeSubnetsDisassociateRouteTable: apiUrl({
        Action: "DescribeSubnetsDisassociateRouteTable",
        Service: "vpc",
        Version: "2016-03-04"
    }),
    ModifyRouteTable: apiUrl({
        Action: "ModifyRouteTable",
        Service: "vpc",
        Version: "2016-03-04"
    }),

    ForceDeleteVpcPeeringConnection: apiUrl({
        Action: "ForceDeleteVpcPeeringConnection",
        Service,
        Version
    }),

    //高可用虚拟IP
    DescribeHaVips: apiUrl({
        Action: "DescribeHaVips",
        Service,
        Version
    }),

    CreateHaVip: apiUrl({
        Action: "CreateHaVip",
        Service,
        Version
    }),

    DeleteHaVip: apiUrl({
        Action: "DeleteHaVip",
        Service,
        Version
    }),

    AssociateHaVip: apiUrl({
        Action: "AssociateHaVip",
        Service,
        Version
    }),

    UnAssociateHaVip: apiUrl({
        Action: "UnAssociateHaVip",
        Service,
        Version
    }),

    AddSecondaryCidrBlock: apiUrl({
        Action: "AddSecondaryCidrBlock",
        Service,
        Version
    }),

    DeleteSecondaryCidrBlock: apiUrl({
        Action: "DeleteSecondaryCidrBlock",
        Service,
        Version
    }),
    //弹性网卡管理私网ip

    AllocationPrivateIpAddress: {
        url: apiUrl({
            Action: "AllocationPrivateIpAddress",
            Service,
            Version
        }),
        method: "post"
    },

    QueryInstancePrivateIpQuota: apiUrl({
        Action: "QueryInstancePrivateIpQuota",
        Service: "kec",
        Version
    }),

    CenTrialLimitConfig: apiUrl({
        Action: "CenTrialLimitConfig",
        Service: "cen",
        Version
    }),

     // 检查新路由表的权限
     CheckNewRouteTableRegion: apiUrl({
        Action: "CheckNewRouteTableRegion",
        Service: "vpc",
        Version: "2016-03-04"
    }),

};
